import { Box, Tooltip } from "@mui/material";
import { FileField, RequestFile } from "models/interfaces";

const CustomRadioFieldElement = ({
  field,
  dispatch,
  selectedFile,
  coords,
  disableFields,
}: {
  field: FileField;
  dispatch: Function;
  selectedFile: RequestFile;
  coords?: any;
  disableFields?: boolean;
}) => {
  const isChecked = field.value === "true";
  const minDim = Math.max(
    8,
    Math.min(coords?.pageWidth ?? 14, coords?.pageHeight ?? 14),
  );
  const circleDiameter = minDim * 0.55;
  const innerDot = circleDiameter * 0.5;

  const interactive = !!disableFields && !field.readOnly && !!field.groupId;

  const handleClick = () => {
    if (!interactive) return;
    dispatch({
      type: "UPDATE_RADIO_GROUP",
      fileId: selectedFile.unsignedPdf,
      groupId: field.groupId,
      selectedFieldId: field.id,
    });
  };

  return (
    <Tooltip title={field.toolTip || ""} placement="top" arrow>
      <Box
        role="radio"
        aria-checked={isChecked}
        aria-label={field.toolTip || "Radio option"}
        aria-disabled={!interactive}
        tabIndex={interactive ? 0 : -1}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (interactive && (e.key === " " || e.key === "Enter")) {
            e.preventDefault();
            handleClick();
          }
        }}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: interactive ? "pointer" : "default",
          backgroundColor: "transparent",
          "&:focus-visible": {
            outline: "2px solid red",
            outlineOffset: "2px",
          },
        }}
      >
        <Box
          sx={{
            width: circleDiameter,
            height: circleDiameter,
            borderRadius: "50%",
            border: "1.5px solid red",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isChecked && (
            <Box
              sx={{
                width: innerDot,
                height: innerDot,
                borderRadius: "50%",
                backgroundColor: "red",
              }}
            />
          )}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default CustomRadioFieldElement;
